var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2654",
    "data-name": "Group 2654",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.985,
    height: 18,
    viewBox: "0 0 17.985 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1772",
    "data-name": "Rectangle 1772",
    width: 17.985,
    height: 18,
    fill: "#474747"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2653",
    "data-name": "Group 2653",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    d: "M4.125,66.015H.375A.375.375,0,0,0,0,66.39v9a.375.375,0,0,0,.375.375h3.75A.375.375,0,0,0,4.5,75.39v-9a.375.375,0,0,0-.375-.375",
    transform: "translate(0 -57.765)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M58.017,0h-3.75a.375.375,0,0,0-.375.375v17.25a.375.375,0,0,0,.375.375h3.75a.375.375,0,0,0,.375-.375V.375A.375.375,0,0,0,58.017,0",
    transform: "translate(-47.157)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M112.029,30.006h-3.75a.375.375,0,0,0-.375.375v13.5a.375.375,0,0,0,.375.375h3.75a.375.375,0,0,0,.375-.375v-13.5a.375.375,0,0,0-.375-.375",
    transform: "translate(-94.419 -26.256)",
    fill: "#474747"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgState);
export default __webpack_public_path__ + "static/media/state.d7516fd6dda2e3e0f7b77fdfd0f327cf.svg";
export { ForwardRef as ReactComponent };